/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import Moment from 'moment';
import 'moment/dist/locale/pt-br';
import 'moment/dist/locale/es';
import {Helmet} from 'react-helmet';

import {getCurrentLang} from '../utils/i18n';
import {PageBodyWrapper, tabletMediaQuery} from '../styles';

import CNitoLogo from '../assets/cnito_logo.gif';
import CNitoTile from '../assets/cnito_tile.png';

Moment.locale(getCurrentLang());

const Cartoonito = props => {
    const {t} = useTranslation();

    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        window.addEventListener('focus', () => {
            !isFocused && setIsFocused(true);
        });
        window.addEventListener('click', () => {
            !isFocused && setIsFocused(true);
        });

        // eslint-disable-next-line
    }, []);

    return (
        <Container>
            <Helmet>
                <title>Cartoonito</title>
                <meta name="description" content={t('home.metaDescription')} />
            </Helmet>

            <ContentColumn>
                <Logo />

                <Title>
                    {getCurrentLang() === 'pt'
                        ? 'CHEGOU CARTOONITO'
                        : 'LLEGÓ CARTOONITO'}
                </Title>

                <SizzleReel>
                    <iframe
                        src={
                            getCurrentLang() === 'pt'
                                ? 'https://player.vimeo.com/video/653815950?h=6d090cd4f4&badge=0&autopause=0&player_id=0&app_id=58479'
                                : 'https://player.vimeo.com/video/653815314?h=4675b7074c&badge=0&autopause=0&player_id=0&app_id=58479'
                        }
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen
                        title={
                            getCurrentLang() === 'pt'
                                ? 'Evento Cartoonito - Brasil'
                                : 'Evento Cartoonito - LATAM'
                        }
                    />

                    <script src="https://player.vimeo.com/api/player.js" />
                </SizzleReel>

                <Text>
                    {getCurrentLang() === 'pt'
                        ? 'Este material é de propriedade exclusiva da WarnerMedia, sua distribuição não é permitida.'
                        : 'Este material es propiedad exclusiva de WarnerMedia, su distribución no esta permitida.'}
                </Text>
            </ContentColumn>
        </Container>
    );
};

const Container = styled(PageBodyWrapper)`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    min-height: calc(100vh - 392px);

    ::after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: '';
        display: block;
        background: url(${CNitoTile});
        z-index: -2;
        background-size: 500px;
        background-repeat: repeat;
    }

    ${tabletMediaQuery} {
        padding-top: 80px;
    }
`;

const ContentColumn = styled.div`
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin-top: 56px;
    margin-bottom: 78px;
    max-width: 90%;
    position: relative;

    ::after {
        position: absolute;
        top: 0;
        left: -32px;
        right: -32px;
        bottom: 0;
        content: '';
        display: block;
        background-color: #ffd93f;
        z-index: -1;
        max-width: 100vw;
    }
`;

const Logo = styled.img.attrs(() => {
    return {
        src: CNitoLogo,
    };
})`
    margin: 0 auto 16px auto;
    height: 96px;
    width: auto;
    max-width: 80%;
    object-fit: contain;
`;

const Title = styled.h1`
    color: rgb(236, 0, 140);
    font-family: 'AvenirNextRoundedStd';
    font-size: 28px;
    font-weight: bold;
    line-height: 38px;
    text-align: center;
    max-width: 672px;
    margin: 0 auto 8px auto;
`;

const Text = styled.p`
    max-width: 672px;
    color: rgb(0, 0, 0);
    font-size: 18px;
    font-family: 'AvenirNextRoundedStd';
    font-weight: bold;
    text-align: center;
    line-height: 24px;
    white-space: pre-line;
    margin: 0 auto 24px auto;
`;

const SizzleReel = styled.div`
    width: 50vw;
    background: rgb(0, 0, 0);
    border-radius: 8px;
    overflow: hidden;
    aspect-ratio: 535 / 300;
    display: flex;
    flex-direction: column;
    max-width: 90%;

    iframe {
        flex: 1;
    }
`;

export default Cartoonito;
